<template lang="html">
  <div>
    <TimeSliderList v-if="space" :hours="hours"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TimeSliderList from './TimeSlider/TimeSliderList';

export default {
  components: { TimeSliderList },

  computed: {
    ...mapState(['space']),

    hours() {
      const range = (begin, end) => {
        const x = [];
        for (let i = begin; i <= end; i += 1) { x.push(i); }
        return x;
      };

      if (!this.space.availiblity_start || !this.space.availiblity_end) {
        return range(0, 23);
      }

      const availabilityStart = this.space.availiblity_start.split(':')[0];
      const availabilityEnd = this.space.availiblity_end.split(':')[0];

      return range(parseInt(availabilityStart, 10), parseInt(availabilityEnd, 10));
    },
  },
};
</script>

<style lang="css" scoped>
  div {
    height: auto;
  }

  @media only screen and (max-width: 720px) {
    div {
      height: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue